export default __webpack_public_path__ + "static/media/home_img_2.0ea0ed64.png";